'use client';

import { Turnstile } from '@marsidev/react-turnstile';

interface TurnstileWidgetProps {
  siteKey?: string;
  onVerify: (token: string) => void;
  onError?: () => void;
  onExpire?: () => void;
}

/**
 * Cloudflare Turnstile widget. The site key is passed as a prop from a server
 * component (which reads the runtime env var) rather than from process.env,
 * because NEXT_PUBLIC_* vars are baked in at build time and the Docker build
 * uses a placeholder.
 */
export function TurnstileWidget({
  siteKey,
  onVerify,
  onError,
  onExpire,
}: TurnstileWidgetProps) {
  if (!siteKey) {
    return null;
  }

  return (
    <Turnstile
      siteKey={siteKey}
      onSuccess={onVerify}
      onError={onError}
      onExpire={onExpire}
      options={{
        language: 'auto',
        theme: 'light',
      }}
    />
  );
}
